const style = {
  overlay: {
    width: "100vw",
    height: "100vh",
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 20,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "rgba(0, 0, 0, 0.6)",
    backdropFilter: "blur(5px)",
  },
  modalContainer: {
    width: "100%",
    maxWidth: "500px",
    background: "#2a2f3b",
    borderRadius: "16px",
    boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.37)",
    border: "1px solid #3c4257",
    color: "#FFF",
    display: "flex",
    flexDirection: "column",
  },
  modalHeader: {
    padding: "20px 25px",
    borderBottom: "1px solid #3c4257",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  modalTitle: {
    fontSize: "20px",
    fontWeight: "600",
    margin: 0,
  },
  closeButton: {
    background: "none",
    border: "none",
    color: "#aeb9c4",
    cursor: "pointer",
    padding: "5px",
  },
  form: {
    padding: "25px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  inputGroup: {},
  label: {
    display: "block",
    fontSize: "14px",
    fontWeight: "500",
    marginBottom: "8px",
    color: "#aeb9c4",
  },
  input: {
    width: "100%",
    height: "45px",
    background: "#1e212b",
    border: "1px solid #3c4257",
    borderRadius: "12px",
    padding: "0 20px",
    boxSizing: "border-box",
    color: "#FFF",
    fontSize: "15px",
    outline: "none",
  },
  textarea: {
    height: "100px",
    paddingTop: "12px",
    resize: "vertical",
  },
  buttonArea: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: "10px"
  },
  actionButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    borderRadius: '10px',
    padding: '10px 20px',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
  },
  editButton: {
    background: '#3b82f6',
    color: '#FFF',
  },
  deleteButton: {
    background: 'rgba(255, 91, 91, 0.1)',
    color: '#ff5b5b',
    marginRight: 'auto',
  },
  saveButton: {
    background: '#4ecf78',
    color: '#1e212b',
  },
  cancelButton: {
    background: '#4b5563',
    color: '#FFF',
  },
  toastButtonConfirm: {
    background: '#ef4444',
    color: '#FFF',
    border: 'none',
    padding: '8px 12px',
    borderRadius: '6px',
    cursor: 'pointer',
  },
  toastButtonCancel: {
    background: '#4b5563',
    color: '#FFF',
    border: 'none',
    padding: '8px 12px',
    borderRadius: '6px',
    cursor: 'pointer',
  }
};

export default style;